/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	"use strict";
	/*globals Tc */
	/*jshint smarttabs:true */

	/**
	 * ProductAmountPrice module implementation.
	 *
	 * @author Stefan Maurer, Cesar Keller, Sebastian Bartels
	 * @namespace Tc.Module
	 * @class ProductAmountPrice
	 * @extends Tc.Module
	 */
	Tc.Module.ProductAmountPrice = Tc.Module.extend({

		on: function (callback) {

			callback(); // do not remove!
			this.validMaxNumber();
			// move this here, so the change handler is executed before the change handler Tc.Module.ProductItemGroup.js
			// Tc.Module.ProductItemGroup.js is accessing data that is set in the valueChangeHandler, directly on the object
			$(':input', this.$ctx).on('change', $.proxy(this.valueChangedHandler, this));
		},

		/**
		 * Validates the field content on blur() (min/max and >=0)
		 *
		 * @method after
		 * @return void
		 */

		validMaxNumber: function () {
			var mod = this,
				$ctx = mod.$ctx,
				$inputnumber = $ctx.find("[type=text]"),
				maxnumber = $ctx.find("[type=text]").attr("data-max"),
				errornummeric = $ctx.find(".error-numeric"),

				errormaxed = $ctx.find(".error-maxed");

			debug.log($inputnumber, maxnumber, 'Input Number');
			$inputnumber.keypress(function () {
				var e = window.event||e; // Handle browser compatibility
				var keyID = e.keyCode;

				//space pressed
				if ((keyID == 45) || (keyID == 46) || (keyID == 44)) {
					e.preventDefault(); // Prevent the default action
				}


			});
			$inputnumber.blur(function (e) {

				var inputVal = $(this).val(),
					numericReg = /^\d*[0-9](|.\d*[0-9]|,\d*[0-9])?$/;

				if (inputVal) {
					if(!numericReg.test(inputVal)) {
						errornummeric.show();
					} else {
						errornummeric.hide();
					}

					if (parseInt(inputVal) > parseInt(maxnumber)){
						errormaxed.show();
						$(this).val(0);
						$(this).trigger("change");
					} else {
						errormaxed.hide();
					}
				}

			});
		},

		after: function () {
			var mod = this;
			mod.valueChangedHandler();
			mod.fire("PriceAdded", {}, ["formpriceupdate"]);
		},

		valueChangedHandler: function(event) {
			var mod = this,
				field = event ? $(event.currentTarget) : $(':input', mod.$ctx),
				count = parseInt(field.val()) || 0;
			field.attr('data-hascost', count);
			field.data('hascost', count);
			if (mod.$ctx.data('show-calculated-price')) {
				var priceOnce = field.data('onetime-charge'),
					priceMonthly = field.data('price');

				if (priceOnce) {
					$('.onetime-price .price', mod.$ctx).text(parseFloat(Math.round(count * priceOnce * 100) / 100).toFixed(2));
				}
				if (priceMonthly) {
					$('.monthly-price .price', mod.$ctx).text(parseFloat(Math.round(count * priceMonthly * 100) / 100).toFixed(2));
				}
			}
		}
	});
})(Tc.$);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.ProductAmountPrice.js
// module id = 251
// module chunks = 0